__turbopack_context__.v({
  "main": "MainContainer-module__ENwuKq__main",
});
